/**
 * Free/Pro feature map — the client's single source of truth for gating
 * (design §3). Mirrors the server gates (403 PRO_REQUIRED); the server is
 * authoritative, this only decides what UI to render.
 *
 * Model: Free includes leads, discussion and chat; Pro unlocks PROPOSING and
 * conversion (availability, online payments) plus analytics and reviews.
 * Tiers apply to SERVICE providers only.
 *
 * Sending a proposal moved to Pro (order-creation design §B). Forced rather
 * than chosen: a proposal carries dates, and only a Pro provider can publish
 * the availability those dates are checked against — so a Free provider's
 * every proposal would have failed AVAILABILITY_LOST.
 */
export const FEATURES = {
  /** Reading orders: leads, discussion, chat and private notes. Free (owner decision 2026-10-18). */
  ORDERS: 'booking.orders',
  /** The orders calendar views and the day-availability shortcut. */
  CALENDAR: 'booking.calendar',
  /** Sending a PROPOSAL. Reading the thread and chatting stay free. */
  QUOTE: 'booking.quote',
  AVAILABILITY: 'booking.availability',
  PAYMENTS: 'booking.payments',
  ANALYTICS: 'analytics',
  REVIEWS: 'reviews',
};

const PRO_FEATURES = new Set([
  FEATURES.CALENDAR,
  FEATURES.QUOTE,
  FEATURES.AVAILABILITY,
  FEATURES.PAYMENTS,
  FEATURES.ANALYTICS,
  FEATURES.REVIEWS,
]);

export const hasFeature = (provider, feature) => {
  if (!provider || provider.providerType !== 'SERVICE') return true; // tiers are SERVICE-only
  return Boolean(provider.isProPlan) || !PRO_FEATURES.has(feature);
};

/** Backend-computed: ownerConfirmedAt set AND state APPROVED (design §4.2). */
export const isVerified = (provider) => Boolean(provider?.isVerified);
